import { __zcAsy, __zcFin, __zcFinZ, __zcMkv } from "__zod-compiler-runtime__";
import {safeOptional} from '../../safe-optional'
import * as z from 'zod'

export const AssetSchema = /* @__PURE__ */ (() => {
var __zs=z.lazy(() =>
  z.object({
    fields: z.object({
      description: z.string().optional(),

      file: z.object({
        url: z.string(),
        details: safeOptional(
          z.object({
            image: safeOptional(
              z.object({
                width: z.number(),
                height: z.number(),
              }),
            ),
          }),
        ),
      }),
    }),
  }),
);
var __rf=[__zs._zod.innerType.shape["fields"].shape["file"].shape["details"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __bf_2={};
var __rfn_10=__rf[0];
function __vb_3(input){var __bv_4,__bv_5,__bv_6,__bv_7,__bv_8,__bx_9,__bw_11,__bo_12,__bo_13,__bo_14;if(typeof input!=="object"||input===null||Array.isArray(input))return __bf_2;__bv_4=input["fields"];if(typeof __bv_4!=="object"||__bv_4===null||Array.isArray(__bv_4))return __bf_2;__bv_5=__bv_4["description"];if(!((__bv_5===undefined||(typeof __bv_5==="string"))))return __bf_2;__bv_6=__bv_4["file"];if(typeof __bv_6!=="object"||__bv_6===null||Array.isArray(__bv_6))return __bf_2;__bv_7=__bv_6["url"];if(!(typeof __bv_7==="string"))return __bf_2;__bv_8=__bv_6["details"];if(__bv_8===undefined){__bw_11=undefined;}else{__bx_9=__rfn_10(__bv_8);if(__bx_9 instanceof Promise)__zcAsy();__bw_11=__bx_9;}__bo_12={"url":__bv_7};if(__bw_11!==undefined||("details" in __bv_6)){__bo_12["details"]=__bw_11;}__bo_13={};if(__bv_5!==undefined||("description" in __bv_4)){__bo_13["description"]=__bv_5;}__bo_13["file"]=__bo_12;__bo_14={"fields":__bo_13};return __bo_14;}
var __rfm_z=__zs.safeParse;
function safeParse_AssetSchema(input){
var __bd_15=__vb_3(input);
if(__bd_15!==__bf_2){return{success:true,data:__bd_15};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_AssetSchema,__zs,null,null);
})()

export type Asset = z.infer<typeof AssetSchema>
